var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7911 10.3815C3.48793 10.3815 0.666656 10.8917 0.666656 12.9312C0.666656 14.9722 3.46999 15.5 6.7911 15.5C10.0943 15.5 12.9155 14.9898 12.9155 12.9503C12.9155 10.9093 10.1122 10.3815 6.7911 10.3815Z",
    fill: "#003056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.79111 8.43735C9.04079 8.43735 10.8436 6.67181 10.8436 4.46868C10.8436 2.26554 9.04079 0.5 6.79111 0.5C4.54224 0.5 2.73859 2.26554 2.73859 4.46868C2.73859 6.67181 4.54224 8.43735 6.79111 8.43735Z",
    fill: "#003056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.4778 4.54061C12.4778 5.66254 12.1337 6.70941 11.5303 7.579C11.4676 7.66844 11.523 7.78901 11.6323 7.80818C11.7839 7.83293 11.9397 7.8481 12.0987 7.8513C13.6805 7.89202 15.1002 6.89466 15.4924 5.39264C16.0737 3.16395 14.3679 1.16284 12.1949 1.16284C11.9592 1.16284 11.7334 1.1868 11.5132 1.23072C11.4831 1.2371 11.4504 1.25148 11.4341 1.27703C11.4129 1.30977 11.4284 1.35209 11.4496 1.38004C12.1028 2.27679 12.4778 3.36837 12.4778 4.54061Z",
    fill: "#003056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1492 10.6411C16.8598 10.0366 16.161 9.6222 15.0977 9.41858C14.5962 9.2988 13.2378 9.12871 11.9747 9.15267C11.956 9.15507 11.9454 9.16784 11.9438 9.17583C11.9413 9.1886 11.947 9.20777 11.9715 9.22134C12.5553 9.50402 14.8115 10.7338 14.5277 13.3274C14.5155 13.4408 14.6077 13.5366 14.7226 13.5206C15.2779 13.4432 16.7065 13.1421 17.1492 12.2062C17.3947 11.7111 17.3947 11.1362 17.1492 10.6411Z",
    fill: "#003056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.b917f4a460c7a756dc244874c4f3622c.svg";
export { ForwardRef as ReactComponent };